import React from 'react'

function NotSupportedFormatMask() {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M31.9999 59.7333C47.2816 59.7333 59.7333 47.2985 59.7333 32.0258C59.6818 16.7015 47.2816 4.26666 31.9999 4.26666C16.6669 4.26666 4.2666 16.7015 4.2666 31.9742C4.2666 47.2985 16.6669 59.7333 31.9999 59.7333Z"
                fill="#FCEAEA"
                stroke="#B62626"
                strokeWidth="0.533333"
                strokeMiterlimit="10"
            />
            <path
                d="M51.3813 20.5144V53.6495C51.3813 56.0639 49.4665 57.9787 47.0521 57.9787H17.2472C14.8328 57.9787 12.918 56.0639 12.918 53.6495V10.2741C12.918 7.85976 14.8328 5.94492 17.2472 5.94492H36.8951C37.9774 5.94492 38.9765 6.36119 39.7258 7.11047L50.2158 17.6005C50.9651 18.433 51.3813 19.4321 51.3813 20.5144Z"
                fill="white"
                stroke="#B62626"
                strokeWidth="0.533333"
                strokeMiterlimit="10"
            />
            <path d="M38.6094 6.1105V15.9565C38.6094 17.7222 40.1046 19.1348 41.8038 19.1348H51.3308" fill="#DB3333" />
            <path
                d="M25.779 48.9555H18.8364C18.5774 48.9555 18.3701 48.6802 18.3701 48.3497C18.3701 48.0193 18.5774 47.744 18.8364 47.744H25.779C26.0381 47.744 26.2453 48.0193 26.2453 48.3497C26.2453 48.7352 26.0381 48.9555 25.779 48.9555Z"
                fill="#DB3333"
            />
            <path
                d="M34.6577 15.0317H19.0444C18.6813 15.0317 18.3701 14.7521 18.3701 14.4259C18.3701 14.0997 18.6813 13.8201 19.0444 13.8201H34.6577C35.0208 13.8201 35.332 14.0997 35.332 14.4259C35.332 14.7521 35.0208 15.0317 34.6577 15.0317Z"
                fill="#DB3333"
            />
            <path
                d="M25.0208 18.6665H19.0403C18.6795 18.6665 18.3701 18.3869 18.3701 18.0607C18.3701 17.7345 18.6795 17.4549 19.0403 17.4549H24.9693C25.3302 17.4549 25.6395 17.7345 25.6395 18.0607C25.6395 18.3869 25.3302 18.6665 25.0208 18.6665Z"
                fill="#DB3333"
            />
            <path
                d="M45.7469 39.8688H27.5408H25.5342H19.4655C19.2208 39.8688 18.9761 40.1212 18.9761 40.4746C18.9761 40.7775 19.1718 41.0804 19.4655 41.0804H25.5342H27.5408H45.7469C45.9916 41.0804 46.2363 40.828 46.2363 40.4746C46.1874 40.1212 45.9916 39.8688 45.7469 39.8688Z"
                fill="#DB3333"
            />
            <path
                d="M45.746 35.6283H38.98H36.6756H19.4664C19.2212 35.6283 18.9761 35.8807 18.9761 36.2341C18.9761 36.537 19.1722 36.8399 19.4664 36.8399H36.6756H38.98H45.746C45.9912 36.8399 46.2363 36.5875 46.2363 36.2341C46.1873 35.8807 45.9912 35.6283 45.746 35.6283Z"
                fill="#DB3333"
            />
            <path
                d="M45.7904 31.3879H44.0321H42.2738H19.4645C19.2203 31.3879 18.9761 31.6403 18.9761 31.9937C18.9761 32.2966 19.1714 32.5995 19.4645 32.5995H42.2738H44.2275H45.7416C45.9858 32.5995 46.23 32.3471 46.23 31.9937C46.2789 31.6908 46.0346 31.3879 45.7904 31.3879Z"
                fill="#DB3333"
            />
            <path
                d="M45.7521 27.1473H40.087H38.6828H19.4603C19.2182 27.1473 18.9761 27.3997 18.9761 27.7531C18.9761 28.056 19.1698 28.3589 19.4603 28.3589H38.6828H40.087H45.7037C46.0426 28.3589 46.2363 28.1065 46.2363 27.7531C46.2363 27.4502 46.0426 27.1473 45.7521 27.1473Z"
                fill="#DB3333"
            />
            <path
                d="M59.5064 51.6665C59.2993 52.5437 58.9888 53.4726 58.6264 54.2466C57.6429 56.1558 56.09 57.6523 54.1747 58.6327C52.2077 59.6131 49.8783 60.0259 47.5489 59.5099C42.0619 58.3747 38.542 53.0082 39.6808 47.5384C40.8196 42.0687 46.1513 38.5083 51.6383 39.6951C53.6053 40.1079 55.3135 41.0883 56.7629 42.4299C59.1958 44.8552 60.2311 48.3641 59.5064 51.6665Z"
                fill="#E95959"
                stroke="#B62626"
                strokeWidth="0.533333"
                strokeMiterlimit="10"
            />
            <path
                d="M49.5801 44.9998C49.7097 44.9998 49.8792 45.0258 50.0371 45.0838C50.1775 45.1354 50.3498 45.2286 50.458 45.3904L53.127 48.2234C53.5391 48.661 53.5389 49.4078 53.127 49.8455C52.7006 50.2982 51.9786 50.2826 51.5273 49.8572L51.5186 49.8494L51.71 49.6629L51.5186 49.8484L50.7539 49.0623V53.0125C50.7539 53.6468 50.2553 54.1998 49.6201 54.2C48.9848 54.2 48.4854 53.6469 48.4854 53.0125V49.0623L47.7227 49.8445L47.7236 49.8455C47.2971 50.2983 46.5752 50.2829 46.124 49.8572L46.1182 49.8513L46.1133 49.8455C45.8758 49.5934 45.7647 49.3208 45.7646 49.0349C45.7646 48.9004 45.7895 48.7419 45.8467 48.5935C45.8974 48.4619 45.9828 48.3199 46.1182 48.2166L48.7949 45.3767C48.8786 45.2879 49.0025 45.1983 49.1299 45.1306C49.2532 45.0652 49.4175 44.9999 49.5801 44.9998Z"
                fill="white"
                stroke="#B62626"
                strokeWidth="0.533333"
            />
        </svg>
    )
}

export default NotSupportedFormatMask
